import { User } from '@src/global/types/types';

export const InitialAuthState = {
  user: null as User,
  isLoggedIn: false as boolean,
  isLoading: false as boolean,

  doLogout: () => undefined,
} as const;
